import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledMedicalImagingTable = styled(StyledFlex)`
   height: 100%;
`;
StyledMedicalImagingTable.displayName = 'StyledMedicalImagingTable';
